// abort-reads: ONE AbortController per page visit. Leaving a page (section change) aborts the GETs it still has in flight,
// so an old page's fan-out stops holding the browser's ~6 connections per host while the next page loads.
// Writes are never given this signal (api.js attaches it to GET only).
let ctrl = null;
let key = null;

// Section-level key (module/section) so tab switches inside a mounted page never abort its own reads. A record drawer opened over a
// list (location.state.background) belongs to the background page.
export const navKey = (loc) => {
  const p = (loc && loc.state && loc.state.background && loc.state.background.pathname) || (loc && loc.pathname) || '';
  return p.split('/').filter(Boolean).slice(0, 2).join('/');
};
export function beginNavigation(loc) {
  const k = navKey(loc);
  if (k === key) return false;
  const first = key === null;
  key = k;
  if (ctrl && !first) ctrl.abort();   // the first visit keeps any signal already handed out (shell boot reads)
  if (!first || !ctrl) ctrl = new AbortController();
  return true;
}
export const navSignal = () => (ctrl || (ctrl = new AbortController())).signal;

// Session-stable / shell-level reads that outlive any page: master lists cached in module-level promises, nav badges and polls.
// 47107 A7k: /help is NOT here any more: a per-key help read belongs to the page it was asked on and is cancelled when the user leaves.
// They are never given the navigation signal (an aborted one would be cached as a default or flash an error in the shell).
const KEEP_ALIVE = /^\/(me|auth\/|version|formatting|settings\/general|breed-benchmarks\/global|category-constants|flow-matrix|items|storages|consumption|finance-subtypes|sites|farms|mortality-causes|bands\/lifetime-hd|bands\/list|review\/pending\/count|payments\/attention|period-lock|journal\/clean-state|health\/sanity|sanity\/family-summary|inventory\/(price-alerts|feed-runout)|sales\/credit-alerts|alerts\/live-state|planned-transactions|project-tag-values\/all|refresh-cascade|finance$)|\/count$/;
export function signalFor(endpoint, options = {}) {
  if (options.signal || options.keepAlive || options.noAbort) return options.signal;
  if (String(options.method || 'GET').toUpperCase() !== 'GET' || options.body != null) return undefined;
  return KEEP_ALIVE.test(String(endpoint).split('?')[0]) ? undefined : navSignal();
}
export const isAbortError = (e) => !!e && e.name === 'AbortError';
export const abortError = () => (typeof DOMException === 'function' ? new DOMException('The operation was aborted.', 'AbortError') : Object.assign(new Error('The operation was aborted.'), { name: 'AbortError' }));
